import { ActivationUserComponent } from './../activation-user/activation-user.component';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';
import { Message } from './../../shared/models/system/message';
import { Globals } from 'src/app/shared/services/globals';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http'
import { finalize, takeUntil } from 'rxjs/operators';
//import { UserRegistration } from '../../shared/models/user.registration.interface';
import { Role } from 'src/app/shared/models/Com/Role';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserRegistration } from 'src/app/shared/models/DTO/UserRegistration';
import { GenericVm } from 'src/app/shared/models/system/generic-vm';
import { ToastrService } from 'ngx-toastr';
import { PatientService } from 'src/app/basic-data/services/patient.service';
import { CountryAndCityService } from 'src/app/shared/services/country-and-city.service';
import { PatientDto } from 'src/app/shared/models/DTO/PatientDto';
import { ConfigurationService } from './../services/configuration.service';
import { ConfigurationDto } from './../../shared/models/DTO/configuration-dto';
import { MatDialog } from '@angular/material';
import { ReplaySubject, Subject } from 'rxjs';
import { TermsAndConditionsComponent } from 'src/app/basic-data/terms-and-conditions/terms-and-conditions.component';
import { RegularExpressions } from 'src/app/shared/models/Validation/RegularExpressions';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent implements OnInit {
  patient:PatientDto = new PatientDto();
  submitted: boolean = false;
  hidePassword: boolean = true;
  patientForm: FormGroup;
  userId: string;

  errors: string;
  isRequesting: boolean;

  roles: Role[];
  selectedRoleValue;
  formData: UserRegistration;
  email;
  userName;
  phoneNumber;
  password;
  // firstName;
  // lastName;
  role;
  roleName;
  roleNameHint: boolean;
  focusOut = null;
  configurationData: any;
  configuration:ConfigurationDto=new ConfigurationDto();
  number: any;
  patientData: any;
  userIdPatient: any;

  countries: any[];
  public countryFilterCtrl: FormControl = new FormControl();
  public filteredCountries: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public nationalityFilterCtrl: FormControl = new FormControl();
  public filteredNationalities: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  selectedCountryApi:any;
  countryPhoneCode:any =" ";


  constructor(public dialog: MatDialog,private userService: UserService, private router: Router, public global: Globals, private currentRoute: ActivatedRoute ,
    private toastr: ToastrService, private _PatientService : PatientService, private _CountryAndCityService: CountryAndCityService,
     private configService:ConfigurationService) { }

     protected _onDestroy = new Subject<void>();

  ngOnInit() {
    this.configuration={
      EmailSender:"",
      passSender:"",
      bookDaysGap:0,
      BookDaysView:0
    }
    this.userId = new URLSearchParams (window.location.search).get('userId');

    this.getCountries();

    // this._CountryAndCityService.GetAllCitiesFromApi("EG").subscribe(
    //   (data:any) => {
    //     console.log("Cities :" , data);
    //   },
    //   (error:any) =>{
    //     console.log(error);
    //     this.toastr.error('حدث خطأ فى استيراد المدن');
    //   }
    // );


    if(this.userId){
      // alert(this.userId);

      this._PatientService.getPatientById(this.userId).subscribe(
        (data:any) => {
          console.log(data);
          if(data.status !=-1){
            this.patient= data.data;
            document.getElementById("btnAdd").innerHTML="حفظ التعديل";
          }
          else{
            this.toastr.error('لم يتم العثور على بيانات المستخدم');
          }
        },
        (error:any) =>{
          console.log(error);
          this.toastr.error('حدث خطأ ما');
        }
      );

    }
    else{
      console.log(this.userId ,"user Id");
      this.patient.country="المملكة العربية السعودية";
      this.patient.nationality="المملكة العربية السعودية";
      this.patient.countryPhoneCode = "966"
    }

    this.patientForm = new FormGroup({
      firstName : new FormControl('', [Validators.required , Validators.pattern(RegularExpressions.AllCharactersExceptEnglish)]),
      middleName : new FormControl('', [Validators.required, Validators.pattern(RegularExpressions.AllCharactersExceptEnglish)]),
      lastName : new FormControl('', [Validators.required, Validators.pattern(RegularExpressions.AllCharactersExceptEnglish)]),

      firstNameEn : new FormControl('', [Validators.required , Validators.pattern(RegularExpressions.AllCharactersExceptArabic)]),
      middleNameEn : new FormControl('', [Validators.required, Validators.pattern(RegularExpressions.AllCharactersExceptArabic)]),
      lastNameEn : new FormControl('', [Validators.required, Validators.pattern(RegularExpressions.AllCharactersExceptArabic)]),

      phoneNumber : new FormControl('', [Validators.required, Validators.pattern("([0-9]{10,})$"), Validators.maxLength(11)]),
      email : new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$')]),
      birthDate : new FormControl('', Validators.required),
      country : new FormControl('', Validators.required),
      city : new FormControl('', Validators.required),
      neighborhood : new FormControl(''),
      // address : new FormControl('', [Validators.required,Validators.pattern(/^[\u0621-\u064Aa-zA-Z\s]{2,20}[\-|،][\u0621-\u064Aa-zA-Z\s]{2,20}[\-|،][\u0621-\u064Aa-zA-Z\s]{2,20}$/)]),
      workPlace :  new FormControl(''),
      // idCardNumber: new FormControl('', [Validators.pattern("^([1-2])([0-9]{9,})$") , Validators.maxLength(16)]),
      idCardNumber: new FormControl('', ),
      password: new FormControl('', [ Validators.required , Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{6,}$/)]),
      confirmPassword: new FormControl('', Validators.required),
      nationality: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required),
      type: new FormControl('R', Validators.required),
      acceptTerms: new FormControl('', Validators.requiredTrue)
    });
  }

  getCountries(){
    this._CountryAndCityService.GetAllCountriesFromDb().subscribe(
      (data:any) => {
        this.countries = data.data;
        console.log("Countries :" , this.countries);

        // for countries.
        this.filteredCountries.next(this.countries);
        this.countryFilterCtrl.valueChanges
         .pipe(takeUntil(this._onDestroy))
         .subscribe(() => {
           this.filterCountries();
         });

        // for nationalities.
        this.filteredNationalities.next(this.countries);
        this.nationalityFilterCtrl.valueChanges
         .pipe(takeUntil(this._onDestroy))
         .subscribe(() => {
           this.filterNationalities();
         });
      },
      (error:any) =>{
        console.log(error);
        this.toastr.error('حدث خطأ فى استيراد الدول');
      }
    );
  }
  protected filterCountries() {
    debugger;
    if (!this.countries) {
      return;
    }
    // get the search keyword
    let search = this.countryFilterCtrl.value;

    if (!search) {
      this.filteredCountries.next(this.countries);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter countries
    this.filteredCountries.next(
      this.countries.filter(c => c.nameArabic.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterNationalities() {
    debugger;
    if (!this.countries) {
      return;
    }
    // get the search keyword
    let search = this.nationalityFilterCtrl.value;

    if (!search) {
      this.filteredNationalities.next(this.countries);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter nationalities
    this.filteredNationalities.next(
      this.countries.filter(c => c.nameArabic.toLowerCase().indexOf(search) > -1)
    );
  }

  selectCountry(event){
    console.log(event.value);
    let selectedCountryDb = this.countries.filter(c => c.nameArabic == event.value)[0];
    this.GetCountryDetails(selectedCountryDb.code.toUpperCase());
    //this.GetCountryCities(selectedCountryDb.id);
  }

  GetCountryDetails(countryCode){
    this._CountryAndCityService.GetCountryDetailsFromApi(countryCode).subscribe(
      (res:any) => {
        this.selectedCountryApi = res;
        console.log("Selected Country :" , this.selectedCountryApi);
        this.patient.countryPhoneCode = this.selectedCountryApi.phonecode;
      },
      err => {
        console.log(err);
        this.toastr.error('حدث خطأ فى استيراد الدولة المطلوبة ');
      });
  }

  GetCountryCities(countryId){
    this._CountryAndCityService.GetCountryCitiesFromDb(countryId).subscribe(
      (res:any) => {
        let cities = res.data;
        console.log("Selected Country Cities :" , cities);
      },
      err => {
        console.log(err);
        this.toastr.error('حدث خطأ فى استيراد الدولة المطلوبة ');
      });
  }

  SendMail(){
    //alert(this.patientForm.controls.email.value)
    this.global.spinner = true;

    this._PatientService.SendEmail({Email:this.patientForm.controls.email.value,userId:this.userIdPatient}).subscribe(
      (data:any) => {
        this.global.spinner = false;

        this.openDailog();
        //this.toastr.success('تم الارسال بنجاح.');

     }
      ,(error:any) =>{
        this.toastr.error('خطأ فى الارسال .');
        this.global.spinner = false;

        console.log(error);}

    )
  }
  getConfig(){
    this.configService.getConfigDto().subscribe(
      res => {
        let result = res as any
        this.configuration = result.data;
        this.configuration.EmailSender=result.data.emailSender;
       this.configuration.passSender=result.data.passSender
        console.log(this.configuration)
      },
      err => {
        console.log("err", err)
      })
  }
  addPatient(){
    this.submitted = true;
    console.log(this.patientForm);

    if(this.userId){
      // to skip the validation for these controlles.
      this.patientForm.controls.password.clearValidators();
      this.patientForm.controls.confirmPassword.clearValidators();
      this.patientForm.controls.acceptTerms.clearValidators();
      this.patientForm.controls.password.updateValueAndValidity();
      this.patientForm.controls.confirmPassword.updateValueAndValidity();
      this.patientForm.controls.acceptTerms.updateValueAndValidity();

      if (this.patientForm.invalid){
        this.toastr.error("من فضلك ادخل جميع البيانات.");
        return;
      }

      this._PatientService.updatePatient(this.patient).subscribe(
        (data:any) => {
          console.log(data);
          if(data.status !=-1){
            this.toastr.success('تم التعديل بنجاح.');
          }
          else{
            this.toastr.error('لم يتم التعديل , هناك خطأ ما.');
          }
        },
        (error:any) =>{
          console.log(error);
          this.toastr.error('حدث خطأ ما , لم يتم التعديل.');
        }
      );
      return;
    }

    if (this.patientForm.invalid){
        this.toastr.error("من فضلك ادخل جميع البيانات.");
        return;
    }

    if(this.patientForm.controls.password.value != this.patientForm.controls.confirmPassword.value){
      this.toastr.error('كلمة السر غير متطابقة');
    }

    else{
      console.log(this.patientForm);
      console.log(this.patient);

      this._PatientService.addPatient(this.patient).subscribe(
            (data:any) => {

              console.log(data);
              if(data.status !=-1){
                this.patientData=data.data
                this.userIdPatient=data.data.userId
                console.log('dddddddddddarar',this.patientData,this.userIdPatient)
                // this.SendMail();
                this.toastr.success('تم تسجيل مستخدم جديد بنجاح.');
                //this.patientForm.reset();
                this.router.navigateByUrl("/login?email=" + this.patient.email);

              }
              else{
                this.toastr.error('لم يتم التسجيل , هناك خطأ ما.');
              }
            },
            (error:any) =>{
              console.log(error);
              this.toastr.error('حدث خطأ ما , لم يتم التسجيل.');
            }
      );
    }
  }

  EmailExist(){
    if(this.patient.email){
      this._PatientService.EmailExist(this.patient.email ,this.userId ).subscribe(
        (data:any) => {
          console.log(data);
          if(data.status !=-1){
            console.log("Validate Email");
            console.log(data.data);
            if(data.data == true){
              this.patientForm.controls.email.setErrors({notUnique:true});
            }
          }
          else{
            this.toastr.error('لم يتم الفحص هناك خطأ ما.');
          }
        },
        (error:any) =>{
          console.log(error);
          //this.toastr.error('حدث خطأ ما , لم يتم التأكد من عدم تكرار البريد الالكترونى.');
        }
      );
    }
  }

  PhoneNumberExist(){
    if(this.patient.phoneNumber){
      this._PatientService.PhoneNumberExist(this.patient.phoneNumber ,this.userId ).subscribe(
        (data:any) => {
          console.log(data);
          if(data.status !=-1){
            console.log("Validate Email");
            console.log(data.data);
            if(data.data == true){
              this.patientForm.controls.phoneNumber.setErrors({notUnique:true});
            }
          }
          else{
            this.toastr.error('لم يتم الفحص هناك خطأ ما.');
          }
        },
        (error:any) =>{
          console.log(error);
          //this.toastr.error('حدث خطأ ما , لم يتم التأكد من عدم تكرار الجوال.');
        });
    }
  }

  IdCardNumberExist(){
    if(this.patient.idCardNumber){
      this._PatientService.IdCardNumberExist(this.patient.idCardNumber ,this.userId ).subscribe(
        (data:any) => {
          console.log(data);
          if(data.status !=-1){
            console.log("Validate Email");
            console.log(data.data);
            if(data.data == true){
              this.patientForm.controls.idCardNumber.setErrors({notUnique:true});
            }
          }
          else{
            this.toastr.error('لم يتم الفحص هناك خطأ ما.');
          }
        },
        (error:any) =>{
          console.log(error);
          // this.toastr.error('حدث خطأ ما , لم يتم التأكد من عدم تكرار الهوية.');
        });
    }
  }


  focusout(user) {
    //alert(user.value);
    this.userService.isUserExist(user.value).then((result) => {
      // alert(result);

      this.global.status = (result as GenericVm<string>).status;
      if (this.global.status == ResponseStatusEnum.isExits) {
        this.focusOut = '';
      } else {
        this.focusOut = null;
      }
    }).catch(res => this.global.spinner = false);
  }

  // SetActive(state) {
  //   this.formData.active = state;
  // }

  roleTypeState(roleType: any) {//College,University,
    //console.log(courseType.name);

    if (this.formData.roleName.includes(roleType)) {
      //this.formData.roleName.push(roleType);
      return true;

    }
    else {
      return false;
    }
  }

  // getFirstnameErrorMessage() {
  //   return this.firstName.hasError('required') ? 'You must enter a value' :
  //     this.firstName.hasError('minLength') ? 'You must enter At least Two Character' :
  //       this.firstName.hasError('maxLength') ? 'You must enter maxLength 15 Character' :

  //         '';
  // }
  // getLastnameErrorMessage() {
  //   return this.lastName.hasError('required') ? 'You must enter a value' :
  //     this.lastName.hasError('minLength') ? 'You must enter At least Two Character' :
  //       this.lastName.hasError('maxLength') ? 'You must enter maxLength 15 Character' :

  //         '';
  // }
  getEmailErrorMessage() {

    return this.email.hasError('required') ? 'You must enter a value' :
      this.email.hasError('pattern') ? 'Not a valid email' : '';

  }

  getPasswordErrorMessage() {
    return this.password.hasError('required') ? 'You must enter a value' :
      this.password.hasError('minLength') ? 'Not a valid phone number' :
        this.password.hasError('maxLength') ? 'Not a valid phone number' :

          '';
  }

  /*  getRoleErrorMessage() {
     return this.roleName.hasError('required') ? 'You must enter a value' :


         '';
   } */

  setRoleType(e) {

    if (e.target.checked) {
      this.formData.roleName.push(e.target.id);
      this.roleName = true;
      this.roleNameHint = false;
    }
    else {
      this.formData.roleName = this.formData.roleName.filter(item => item != e.target.id);
      if (this.formData.roleName.length == 0) {
        this.roleName = false;
        this.roleNameHint = true;

      }
    }
  }
  registerUser() {


    // this.submitted = true;
    // this.isRequesting = true;
    // this.errors = '';

    // this.userService.addUser(this.formData.userName, this.formData.userName, this.formData.password,
    //   this.formData.firstName, this.formData.lastName, this.formData.address, this.formData.roleName, this.userId, this.formData.active)
    //   .pipe(finalize(() => { this.isRequesting = false; }))
    //   .subscribe(
    //     result => {

    //       this.global.Messages = result.messages;
    //       this.global.status = result.status;

    //       if (this.global.status == ResponseStatusEnum.OK) {
    //         this.router.navigateByUrl("admin/user-view");
    //       }
    //     });

    this.userService.addUser(this.formData.email, this.formData.userName, this.formData.phoneNumber, this.formData.password, "VisitorPatient" , this.userId)
      .pipe(finalize(() => { this.isRequesting = false; }))
      .subscribe(
        result => {

          this.global.Messages = result.messages;
          this.global.status = result.status;

          if (this.global.status == ResponseStatusEnum.OK) {
            this.router.navigateByUrl("/auth");
          }
        });
  }
  openDailog(){
    let dialogRef= this.dialog.open(ActivationUserComponent, {backdropClass: 'cdk-overlay-dark-backdrop',
    hasBackdrop: true ,width:"550px",height:"580px",
      data: { userid:this.userIdPatient , email:this.patient.email , password:this.patient.password}
    });

    // dialogRef.afterClosed().subscribe(res =>{
    //   console.log(res,'res')
    //   if(res.data=="isActive"){
    //     this.router.navigateByUrl("/landind");

    //   }
    //   if(res.data=="notActive")
    //   {
    //     this.router.navigateByUrl("");

    //   }
    // })
  }
  openTermsAndConditions(){
    let dialogRef = this.dialog.open(TermsAndConditionsComponent , {
      hasBackdrop:true,
      autoFocus:true,
      width:"50%"
    });
  }

}
